import { persistMixin, refetchQueryMixin, restartQueriesMixin, safeMixin, watchAllMixin } from "@wittignl/js-core";

export default function(app){

    // Core
    app.mixin(persistMixin);
    app.mixin(refetchQueryMixin);
    app.mixin(restartQueriesMixin);
    app.mixin(safeMixin);
    app.mixin(watchAllMixin);
}